he.pages.aboutUs.init = function () {
    const selector = '.about-us-counting-numbers .counter:not(.animated)';

    inView(selector).on('enter', function (el) {
        he.countingNumbers(el);
    });
};